import React from 'react';
import { Button } from 'semantic-ui-react';
import OutgoingMobilityStudentList from '../../OutgoingMobilityStudents/OutgoingMobilityStudentList';

class StudentsMobilityReport extends React.Component {
    constructor(props) {
        super(props);

        this.mobilityListRef = React.createRef();
        this.state = {
            reportRequested: false,
        };
    }

    showReport = () => {
        this.setState({ reportRequested: true }, () => {
            if (this.mobilityListRef.current) {
                this.mobilityListRef.current.applyFilters();
            }
        });
    }

    handleFiltersChange = () => {
        this.setState({ reportRequested: false });
    }

    render() {
        return (
            <div>
                <OutgoingMobilityStudentList
                    ref={this.mobilityListRef}
                    compact
                    hideStudentFacultyColumn
                    filtersInBox
                    showResults={this.state.reportRequested}
                    applyFiltersOnChange={false}
                    onFiltersChange={this.handleFiltersChange}
                    plainDetails
                    reportPdf
                    renderActions={() => (
                        <div>
                            <Button basic="true" color="blue" floated="right" onClick={this.props.closeReport}>
                                Odustani
                            </Button>
                            <Button color="blue" floated="right" onClick={this.showReport}>
                                Prikaži izvještaj
                            </Button>
                            <br /><br /><br />
                        </div>
                    )}
                />
            </div>
        );
    }
}

export default StudentsMobilityReport;



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentsReports/StudentsMobilityReport.js